import { ApiEndpointTags } from '../imago-mp.types';
import type { Subscription, SubscriptionApiItem } from './subscriptions-query';
import { transformSubscription } from './subscriptions-query';

export type UpdateSubscriptionInput = {
    id: string;
    subscriptionName: string;
    customerName: string;
    companyName: string;
    salesforceLink: string;
    comment: string;
    capacityGroupId: string;
    capacityGroupName: string;
};

type UpdateSubscriptionResponse = {
    subscription?: SubscriptionApiItem;
};

export const updateSubscriptionMutation = {
    query: ({ id, capacityGroupId, ...fields }: UpdateSubscriptionInput) => ({
        url: `/mp/1/subscriptions/${id}`,
        method: 'put',
        body: {
            subscription: {
                id,
                ...fields,
                // capacityGroupId is a Postgres UUID column; '' is invalid
                // UUID syntax and fails the update, so send null when blank.
                capacityGroupId: capacityGroupId || null,
            },
        },
    }),
    transformResponse: (
        response: UpdateSubscriptionResponse,
        _meta: unknown,
        arg: UpdateSubscriptionInput,
    ): Subscription => {
        const sub = response?.subscription ?? {};
        return transformSubscription({ ...sub, id: sub.id ?? arg.id });
    },
    invalidatesTags: (
        _result: Subscription | undefined,
        _error: unknown,
        arg: UpdateSubscriptionInput,
    ) => [{ type: ApiEndpointTags.Subscription, id: arg.id }, ApiEndpointTags.Subscriptions],
};
